'use strict';
/* eslint no-console: 0 */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitForm = undefined;

var _noAuthApiClient = require('hub-http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {String} formUrl
 * @param {Object} data
 * @return {Promise}
 */

var submitForm = exports.submitForm = function submitForm(formUrl, data) {
  if (_enviro2.default.getShort() !== 'prod') {
    console.log('Submission to pql form', formUrl, data);
  }

  return _noAuthApiClient2.default.post(formUrl, { data: data });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/api/submitForm.js
// module id = 530
// module chunks = 3 4 5